import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { professionals } from './professionals.reducer';
import { wanted } from './wanted.reducer';
import { spotservellience } from './spotservellience.reducer';
const rootReducer = combineReducers({
  authentication,
  users,
  professionals,
  alert,
  wanted,
  spotservellience
});

export default rootReducer;